import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import 'wobi-web-common/dist/v2/tokens/fonts.css';
import 'wobi-web-common/dist/v2/tokens/spacing.css';
import 'wobi-web-common/dist/v2/tokens/radius.css';
import 'wobi-web-common/dist/v2/tokens/shadow.css';
import 'wobi-web-common/dist/v2/tokens/motion.css';
import App from './App';
import { Router } from 'react-router-dom';
import WobiThemeProvider from 'wobi-web-common/dist/components/WobiThemeProvider';
import { IntlProvider } from 'react-intl';
import messages_he from './messages/he';
import rollbar from './config/rollbar';
import TagManager from 'react-gtm-module';
import { createBrowserHistory } from 'history';
import patchBlockFn from 'history-block-async';
import { agentDeveloperUtils } from 'wobi-web-common/dist/components/utils/helpers';
import { extendTravelTheme } from './config/travelTheme';

const defaultLanguage = 'he';
const messages = {
  he: messages_he,
};

window.rollbar = rollbar;

const gtmEnv = {
  gtmId: agentDeveloperUtils.getGtmId(),
};
TagManager.initialize(gtmEnv);

const AdditionalGtmIdArr = agentDeveloperUtils.getAdditionalTagManegerIds();
if (AdditionalGtmIdArr && Array.isArray(AdditionalGtmIdArr) && AdditionalGtmIdArr.length > 0) {
  for (const additionalGtmId of AdditionalGtmIdArr) {
    const additionalGtmEnviroment = {
      gtmId: additionalGtmId,
    };
    TagManager.initialize(additionalGtmEnviroment);
  }
}

const history = patchBlockFn(createBrowserHistory());

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <IntlProvider locale={defaultLanguage} messages={messages[defaultLanguage]}>
    <WobiThemeProvider fontFamily='Rubik, "Segoe UI", system-ui, sans-serif'>
      <ThemeProvider theme={extendTravelTheme}>
        <Router history={history}>
          <App />
        </Router>
      </ThemeProvider>
    </WobiThemeProvider>
  </IntlProvider>
);